import { useSelector } from "react-redux";

export function useAdvisorInvites() {
  return useSelector((state) => state.advisorInvites);
}
